import React from "react";

export function StatCard({ label, value, icon, accent = false, sub, testId }) {
  return (
    <div
      data-testid={testId}
      className={`card-soft p-5 transition-all hover:-translate-y-0.5 hover:shadow-md ${
        accent ? "bg-emerald-50 border-emerald-100" : ""
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-wider text-muted-foreground">{label}</div>
          <div className={`mt-2 text-3xl font-display font-bold ${accent ? "text-emerald-600" : "text-foreground"}`}>
            {value}
          </div>
          {sub ? <div className="mt-1 text-xs text-muted-foreground">{sub}</div> : null}
        </div>
        <div
          className={`w-10 h-10 rounded-xl flex items-center justify-center ${
            accent ? "bg-emerald-100 text-emerald-600" : "bg-primary/10 text-primary"
          }`}
        >
          {icon}
        </div>
      </div>
    </div>
  );
}
